/**
 * * Descrição das configurações de uma checkbox.
 */
export class CheckboxConfig {
    constructor(
        /**
         * * Texto da checkbox.
         */
        public label: string,
        /**
         * * Valor da checkbox.
         */
        public value: string,
        /**
         * * Id do elemento da checkbox.
         */
        public id?: string,
        /**
         * * Estado da Checkbox selecionada.
         */
        public checked?: boolean,
        /**
         * * Estado da Checkbox desabilitada.
         */
        public disabled?: boolean
    ) {}
}
